import {Injectable} from '@angular/core';
import {Http,Headers,RequestOptions} from "@angular/http";
import 'rxjs/Rx';
import {Router} from "@angular/router";
import {UserM} from "../model/user.model";
import {Util} from "../util/util";


@Injectable()
export class AuthService {

  constructor(private http: Http, private router: Router) {
  }

  checkLogin() {
    return this.http.get('/api/authUtil/checkLogin').map(res => res);
  }

  login(user:UserM){
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let options = new RequestOptions({ headers: headers });

    return this.http.post(`/api/authen/signin_mobile/`,user,options).map(res=>res.json());
  }

  signup(userType:string,user:UserM){
    user.type = userType;
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let options = new RequestOptions({ headers: headers });

    return this.http.post(`/api/authen/signup/${userType}`,user,options).map(res=>res.json());
  }

  signout(){
    return this.http.get('/api/authen/signout').map(res => res.json());
  }

  getUserInfo(){
    return this.http.get('/api/authen/getUserInfo').map(res => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts